export default __webpack_public_path__ + "static/og-5386f9e5f976522a9642f750a24c5550.jpg";